import { state } from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const brandUnit = {
  actions,
  getters,
  mutations,
  state,
};

export default brandUnit;
